import { useQuery, useMutation, useQueryClient } from "@tanstack/react-query";
import {
  listEdcConnections,
  getIntegrationBranding,
  testEdcConnection,
  triggerEdcSync,
  configureEdcConnection,
} from "@/api/client";

export function useEdcConnections(studyId?: string) {
  return useQuery({
    queryKey: ["edcConnections", studyId ?? "all"],
    queryFn: () => listEdcConnections(studyId ? { studyId } : {}),
    staleTime: 30 * 1000,
  });
}

export function useIntegrationBranding() {
  return useQuery({
    queryKey: ["integrationBranding"],
    queryFn: () => getIntegrationBranding({}),
    staleTime: 60 * 60 * 1000, // branding rarely changes
  });
}

export function useConfigureConnection() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: configureEdcConnection,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["edcConnections"] });
    },
  });
}

export function useTestConnection() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: testEdcConnection,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["edcConnections"] });
    },
  });
}

export function useTriggerSync() {
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: triggerEdcSync,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ["edcConnections"] });
      queryClient.invalidateQueries({ queryKey: ["studies"] });
      queryClient.invalidateQueries({ queryKey: ["sites"] });
    },
  });
}
